angular.module('schoolLinqApp').directive('permissionSection', function () {
	return {
		scope: {
			module: '=',
		},
		replace: true,
		restrict: 'E',
		template: require('@ajs/templates/permissionSection.html'),
	};
});
